// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87190892","732":"911f6c42","977":"f0b4a950"}[chunkId] + ".chunk.js";
};